let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("6PfTa")).then(() => parcelRequire('9c3LE'));